module.exports = __webpack_public_path__ + "img/home-company-info-phone.e86f272e.png";